import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-711f157e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wallet-connect-dialog"
};
const _hoisted_2 = {
  key: 0,
  class: "page word-break-word2"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Connect wallet", -1));
const _hoisted_5 = {
  class: "main"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 1,
  class: "page page2 word-break-word2"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Sign in to Game")], -1));
const _hoisted_11 = {
  class: "main"
};
import { ref, onMounted, getCurrentInstance, watch, computed } from "vue";
// 钱包适配器
import { useWallet } from "solana-wallets-vue";
import bs58 from "bs58";
import { setCookie } from "@/utils";
export default {
  __name: 'index',
  props: ["walletList"],
  setup(__props, {
    expose: __expose
  }) {
    const {
      $Toast,
      $store,
      $api
    } = getCurrentInstance().proxy;
    const {
      wallet,
      select,
      connect,
      connected,
      signMessage,
      publicKey
    } = useWallet();
    const isShowSheet = ref(false);
    const signLoading = ref(false);
    const status = ref(1);
    const propsData = __props;
    // 签名
    const loginSignStore = computed(() => $store.state.loginSign);
    // 上次签名地址
    const lastSignedAddress = computed(() => $store.state.lastSignedAddress);
    onMounted(() => {
      // 监听 publicKey 的变化
      watch(publicKey, (newKey, oldKey) => {
        const newKeyBs58 = newKey?.toBase58();
        const oldKeyBs58 = oldKey?.toBase58();

        // 如果新旧公钥相同，直接返回，避免重复处理,okx触发两次
        if (newKeyBs58 === oldKeyBs58) {
          return;
        }
        // 连接成功后的操作
        if (connected.value && newKey && lastSignedAddress.value !== newKeyBs58) {
          $store.commit("updateLoginSign", "");
          // 在此处理账户切换逻辑
          if (connected.value && !loginSignStore.value) {
            // 连接成功后的操作
            signTheMessage();
          }
        } else {
          isShowSheet.value = false;
          status.value = 1;
        }
      }, {
        immediate: true
      } // 初次加载时立即执行
      );
    });
    function getFlag(item) {
      isShowSheet.value = item.type;
      status.value = 1;
    }
    __expose({
      getFlag
    });
    async function onSwitchWallet(item) {
      select(item.adapter.name);
      setTimeout(async () => {
        if (wallet.value) {
          await connect();
        }
      }, 0);
    }
    const signTheMessage = async () => {
      if (signMessage.value) {
        isShowSheet.value = true;
        status.value = 2;
        signLoading.value = true;
        try {
          const currentTime = Date.parse(new Date()) / 1000;
          const encodedMessage = new TextEncoder().encode(currentTime);
          const signature = await signMessage.value(encodedMessage);
          const signature_bs58 = bs58.encode(signature);
          const newKeyBs58 = publicKey?.value?.toBase58();
          if (!newKeyBs58) {
            $Toast({
              message: "Wallet error, please refresh the page and try again!",
              status: "warning"
            });
            return;
          }
          // 调中心化接口登录
          getNewGameSignin({
            pubkey: newKeyBs58,
            msg: currentTime,
            sign: signature_bs58
          });
        } catch (error) {
          status.value = 2;
          signLoading.value = false;
          $store.commit("updateLoginSign", "");
          if (typeof error === "object" && error !== null) {
            if (error.message.includes("User rejected the request")) {
              $Toast({
                message: "User rejected the request",
                status: "fail",
                position: "top"
              });
            }
          } else {
            $Toast({
              message: "Transaction failed" + error,
              status: "fail",
              position: "top"
            });
          }
        }
      } else {
        signLoading.value = false;
        $Toast({
          message: "Sign Message is not supported by the selected wallet.",
          status: "fail"
        });
      }
    };
    async function onSignMessage() {
      await connect().then(() => {
        if (connected.value) {
          // 连接成功后的操作
          signTheMessage();
        }
      }).catch(() => {
        signLoading.value = false;
      });
    }
    function getNewGameSignin(params) {
      $api.getNewGameSignin(params).then(res => {
        if (res.error_code >= 0) {
          status.value = 2;
          signLoading.value = false;
          $store.commit("updateLoginSign", "");
          $Toast({
            message: res.message,
            status: "fail",
            duration: 3000
          });
        } else {
          const data = res.data;
          $store.commit("updateLastSignedAddress", params.pubkey);
          $store.commit("updateLoginSign", params.sign);
          setCookie("login_token", data.token);
          setCookie("login_secret", data.secret);
          isShowSheet.value = false;
          signLoading.value = false;
        }
      }).catch(err => {
        status.value = 2;
        signLoading.value = false;
        if (err.time_error_code) {
          $Toast({
            message: "The request timed out and was canceled. Please check your network settings.",
            status: "fail",
            duration: 3000
          });
        }
      });
    }
    function cancelClick() {
      isShowSheet.value = false;
    }
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_van_button = _resolveComponent("van-button");
      const _component_my_van_dialog = _resolveComponent("my-van-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_my_van_dialog, {
        className: "my-wallet-connect-dialog",
        show: isShowSheet.value,
        showConfirmButton: false
      }, {
        default: _withCtx(() => [status.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
          class: "exit",
          onClick: cancelClick
        }, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-exit",
          class: "icon"
        })])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsData.walletList, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [item.readyState != 'NotDetected' ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onClick: $event => onSwitchWallet(item)
          }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
            src: item.adapter.icon,
            alt: ""
          }, null, 8, _hoisted_8), _createElementVNode("p", null, _toDisplayString(item.adapter.name), 1)]), _createVNode(_component_svg_icon, {
            "icon-class": "icon-arrow-right",
            class: "icon"
          })], 8, _hoisted_6)) : _createCommentVNode("", true)], 64);
        }), 128))])])])) : _createCommentVNode("", true), status.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_button, {
          class: _normalizeClass(['sign', signLoading.value ? 'loading' : '']),
          onClick: _cache[0] || (_cache[0] = $event => onSignMessage()),
          loading: signLoading.value,
          "loading-text": "Confirm in your wallet"
        }, {
          default: _withCtx(() => [_createTextVNode(" Sign message ")]),
          _: 1
        }, 8, ["class", "loading"])])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};